export default __webpack_public_path__ + "static/media/shopping-cart-plus.7c96c69e.png";